import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["handle"]
  static values = { min: Number, max: Number, step: { type: Number, default: 16 }, cookie: String }

  connect() {
    this.handleTarget.setAttribute("aria-valuenow", this.width)
  }

  start(event) {
    event.preventDefault()
    this.dragOrigin = { x: event.clientX, width: this.width }
    this.handleTarget.setPointerCapture(event.pointerId)
    this.element.classList.add("is-resizing")
  }

  drag(event) {
    if (!this.dragOrigin) return

    this.resize(this.dragOrigin.width + event.clientX - this.dragOrigin.x)
  }

  stop() {
    if (!this.dragOrigin) return

    this.dragOrigin = null
    this.element.classList.remove("is-resizing")
    this.save()
  }

  resizeWithKeyboard(event) {
    const direction = { ArrowLeft: -1, ArrowRight: 1 }[event.key]
    if (!direction) return

    event.preventDefault()
    this.resize(this.width + direction * this.stepValue)
    this.save()
  }

  resize(width) {
    const clampedWidth = Math.round(Math.min(Math.max(width, this.minValue), this.maxValue))
    this.element.style.setProperty("--resizable-width", `${clampedWidth}px`)
    this.handleTarget.setAttribute("aria-valuenow", clampedWidth)
  }

  save() {
    document.cookie = `${this.cookieValue}=${this.width}; path=/; max-age=31536000; samesite=lax`
  }

  get width() {
    return Math.round(this.element.getBoundingClientRect().width)
  }
}
